import { RootMedicalRecordsState } from '../types';
import { IStoreState } from 'state/rootReducer';

export const eventStatusSelector = (state: RootMedicalRecordsState) =>
  state.medicalRecords.eventStatus.status;
export const currentRecordSelector = (state: RootMedicalRecordsState) =>
  state.medicalRecords.currentRecord;
export const eventInfoSelector = (state: IStoreState) => state.records.root;
export const statusSelector = (state: RootMedicalRecordsState) =>
  state.medicalRecords.saveCurrentRecord.status;
